import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';
import prependLanguageToLink from 'shared/components/prepend-language-to-link';
var useNavigate = function useNavigate() {
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    application = _useSelector.application;
  var reactRouterNavigate = useReactRouterNavigate();
  var navigate = useCallback(function (to, options) {
    return reactRouterNavigate(prependLanguageToLink(application.siteLanguage, to), options);
  }, []);
  return navigate;
};
export default useNavigate;